import { QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { API_ERRORS } from '@/constants'

// Note: ElevateOS application works with mobile app, mini apps, 3rd party providers
// that's why by default data is not cached, so we guarantee that data always will be fresh
// we can't expect that cached data will be fresh, because it might have been changed in different place
export const DEFAULT_STALE_TIME = 0

export const DEFAULT_RETRY_COUNT = 1

// NOTE: if the request fails with the following errors, there is no point of retrying
export const retrySkipErrorList: Array<number> = [
  API_ERRORS.BAD_REQUEST,
  API_ERRORS.UNAUTHORIZED,
  API_ERRORS.FORBIDDEN,
  API_ERRORS.NOT_FOUND,
]

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const errorStatus = (error as AxiosError)?.response?.status
        if (typeof errorStatus === 'number' && retrySkipErrorList.includes(errorStatus)) {
          return false
        }

        return failureCount < DEFAULT_RETRY_COUNT
      },
      staleTime: DEFAULT_STALE_TIME,
    },
  },
})
